import { useTranslation } from 'react-i18next';
import NoConnection from '../../assets/svg/no-connection.svg';

export const OfflineHeader = () => {
  const { t } = useTranslation();
  return (
    <div className="">
      <div
        className="flex offline-bg-color
      text-xs leading-[0.75rem] sm:text-base h-10 bg-pyrllrofflineColor
      justify-center flex-row items-center animate__slideInRight animate__animated animate__faster"
      >
        <div className="flex flex-row items-center justify-center">
          <img src={NoConnection} alt="noConnection" className="mr-4" />
          <span className="">
            You are offline, your data will be refreshed once you are back
            online
          </span>
        </div>
      </div>
    </div>
  );
};

export default OfflineHeader;
